import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DialogRef } from '@angular/cdk/dialog';

export interface PerioExamCancelModalPayload {
  discard: boolean;
}

@Component({
  selector: 'lib-perio-exam-cancel-modal',
  imports: [TranslatePipe],
  templateUrl: './perio-exam-cancel-modal.component.html',
  styleUrl: './perio-exam-cancel-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class PerioExamCancelModalComponent {
  private readonly dialogRef = inject(DialogRef<PerioExamCancelModalPayload>);

  protected onDiscardClicked(): void {
    this.dialogRef.close({ discard: true });
  }

  protected onKeepEditingClicked(): void {
    this.dialogRef.close({ discard: false });
  }
}
